export default {
  en: {
    actions: {
      inappropriate_report: 'Report as inappropriate',
      edit: 'Edit',
      delete: 'Delete',
    },
    snack: {
      comment_delete_success: 'Comment deleted successfully',
    },
  },
};
